export default __webpack_public_path__ + "static/media/TXN_QTY_Upload_Template.54d42e76.xlsx";